export default __webpack_public_path__ + "static/media/selfie2.bde94db1.jpg";